// Practitioner types and their corresponding labels for dynamic UI text
export const PRACTITIONER_TYPES = [
  { value: 'تغذية علاجية', label: 'تغذية علاجية' },
  { value: 'تغذية عامة', label: 'تغذية عامة' },
  { value: 'تثقيف صحي', label: 'تثقيف صحي' },
  { value: 'صحة نفسية', label: 'صحة نفسية' },
  { value: 'صحة عامة', label: 'صحة عامة' },
  { value: 'جودة حياة', label: 'جودة حياة' },
  { value: 'صحة شمولية', label: 'صحة شمولية' },
] as const;

interface PractitionerLabels {
  /** e.g. "الطبيب", "الأخصائي", "المثقف الصحي" */
  definite: string;
  /** e.g. "اسم الطبيب", "اسم الأخصائي" */
  nameLabel: string;
  /** e.g. "عن المختص" */
  aboutLabel: string;
  /** e.g. "About the Specialist" */
  aboutLabelEn: string;
  /** Short reference e.g. "طبيب", "أخصائي" */
  short: string;
}

export function getPractitionerLabels(type?: string | null): PractitionerLabels {
  switch (type) {
    case 'تغذية علاجية':
      return {
        definite: 'الأخصائي',
        nameLabel: 'اسم الأخصائي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Specialist',
        short: 'أخصائي',
      };
    case 'تغذية عامة':
      return {
        definite: 'الأخصائي',
        nameLabel: 'اسم الأخصائي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Specialist',
        short: 'أخصائي',
      };
    case 'تثقيف صحي':
      return {
        definite: 'المثقف الصحي',
        nameLabel: 'اسم المثقف الصحي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Health Educator',
        short: 'مثقف صحي',
      };
    case 'صحة نفسية':
      return {
        definite: 'الأخصائي',
        nameLabel: 'اسم الأخصائي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Specialist',
        short: 'أخصائي',
      };
    case 'صحة عامة':
      return {
        definite: 'الممارس الصحي',
        nameLabel: 'اسم الممارس الصحي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Practitioner',
        short: 'ممارس صحي',
      };
    case 'جودة حياة':
      return {
        definite: 'الممارس',
        nameLabel: 'اسم الممارس',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Practitioner',
        short: 'ممارس',
      };
    case 'صحة شمولية':
      return {
        definite: 'الممارس الصحي',
        nameLabel: 'اسم الممارس الصحي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Practitioner',
        short: 'ممارس صحي',
      };
    case 'طب بشري':
      return {
        definite: 'الطبيب',
        nameLabel: 'اسم الطبيب',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Doctor',
        short: 'طبيب',
      };
    default:
      return {
        definite: 'الممارس الصحي',
        nameLabel: 'اسم الممارس الصحي',
        aboutLabel: 'عن المختص',
        aboutLabelEn: 'About the Specialist',
        short: 'ممارس صحي',
      };
  }
}
